module.exports = __webpack_public_path__ + "static/img/wiki2.faf14f96.png";